import { render, staticRenderFns } from "./ModalLeavesEdit.vue?vue&type=template&id=b5ddd0be&scoped=true"
import script from "./ModalLeavesEdit.vue?vue&type=script&lang=js"
export * from "./ModalLeavesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ddd0be",
  null
  
)

export default component.exports